import { Tooltip as ComponentsToltip, IconButton, TooltipContent, TooltipTrigger } from "@bcc-ui/ui-components";
import { useFeature } from "flagged";
import React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps, useSelector } from "react-redux";

import style from "components/header/header.scss";
import DarkModeSwitchIcon from "components/icons/DarkModeSwitchIcon";
import Tooltip from "components/tooltip/Tooltip";
import { ThemeMode } from "domain/themeMode";
import { FLAG_RESTRUCTURED_NAVIGATION } from "services/feature/FeatureFlagService";
import * as settingRepository from "services/settings/settingsRepository";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";
import { StoreState } from "store";
import { Application } from "store/application";
import { applyMode } from "store/theme";
import { resolveColor } from "utils/commonFunctions";

import testIds from "testIds.json";

interface Props {
    textOnly?: boolean;
}

const mapState = () => ({});
const connector = connect(mapState, { applyMode });

const DarkModeSwitch = (props: ConnectedProps<typeof connector> & Props): JSX.Element => {
    const { t } = useTranslation();
    const [mode, setModeState] = React.useState<ThemeMode>(settingRepository.getThemeMode());
    const application = useSelector((state: StoreState) => state.applicationReducer.selected);

    // TODO: BCC-7010: remove isRestructuredNavPanelActive when the RMN is done
    const isRestructuredNavPanelActive = useFeature(FLAG_RESTRUCTURED_NAVIGATION);

    const tooltip =
        settingRepository.getThemeMode() == ThemeMode.DARK ? t("dakrModeSwitch.light") : t("dakrModeSwitch.dark");
    const toggleDarkMode = () => {
        const themeMode = settingRepository.getThemeMode() == ThemeMode.DARK ? ThemeMode.LIGHT : ThemeMode.DARK;
        usageStatisticsService.sendEvent({
            category: Category.HEADER,
            action: Action.CHANGE_USER_THEME,
            label: themeMode,
        });
        setModeState(themeMode);
        settingRepository.setThemeMode(themeMode);
        props.applyMode();
    };
    return (
        <>
            {isRestructuredNavPanelActive ? (
                <ComponentsToltip placement="right">
                    <TooltipContent testId={testIds.navigation.darkModeSwitch.darkModeSwitchButtonTooltip}>
                        {tooltip}
                    </TooltipContent>
                    <TooltipTrigger testId={testIds.navigation.darkModeSwitch.darkModeSwitchButtonTrigger}>
                        <IconButton
                            testId={testIds.navigation.darkModeSwitch.darkModeSwitchButton}
                            onClick={toggleDarkMode}
                        >
                            <DarkModeSwitchIcon
                                color={
                                    application === Application.BAM
                                        ? resolveColor("--theme-primary")
                                        : resolveColor("--theme-icon-fill-white")
                                }
                                darkMode={mode === ThemeMode.DARK}
                            />
                        </IconButton>
                    </TooltipTrigger>
                </ComponentsToltip>
            ) : (
                <Tooltip content={tooltip}>
                    <button
                        onClick={toggleDarkMode}
                        className={style.button}
                        data-testid={testIds.navigation.darkModeSwitch.darkModeSwitchButton}
                    >
                        {props.textOnly ? (
                            <span>{tooltip}</span>
                        ) : (
                            <div className={style.darkModeSwitchIcon}>
                                <DarkModeSwitchIcon
                                    color={
                                        application === Application.BAM
                                            ? resolveColor("--theme-primary")
                                            : resolveColor("--theme-icon-fill-white")
                                    }
                                    darkMode={mode === ThemeMode.DARK}
                                />
                            </div>
                        )}
                    </button>
                </Tooltip>
            )}
        </>
    );
};

export default connector(DarkModeSwitch);
